// extracted by mini-css-extract-plugin
module.exports = {"install":"style_install__x_02W","t1":"style_t1__Ba1FB","t2":"style_t2__2UmZX"};